import type { Chapter } from '@code-arcade/engine'

export const chapter1: Chapter = {
  id: 'chapter-1',
  number: 1,
  title: 'Day One',
  company: 'Innotek Systems Inc.',
  devTitle: 'Junior Developer',
  conflict: 'Legacy codebase, no git history, and a PM who thinks O(n²) is a font size.',
  intro: [
    {
      character: 'the-algorithm',
      mood: 'idle',
      dialogue:
        'Meet Dev Lama. Computer science degree. Student loans. A LinkedIn that says "passionate about scalability."',
    },
    {
      character: 'dev-lama',
      mood: 'idle',
      dialogue: 'First day at Innotek Systems. The codebase is 11 years old. There is no README.',
    },
    {
      character: 'chad-mercer',
      mood: 'idle',
      dialogue:
        "Hey. I'm Chad. I go by 10x. Everyone calls me that. I named myself that. No one else did.",
    },
    {
      character: 'stacy-queue',
      mood: 'urgent',
      dialogue:
        'Great, you\'re here! We need the admin table sorted by end of day. I already told the client it\'s done.',
    },
    {
      character: 'dev-lama',
      mood: 'stressed',
      dialogue: 'Okay. I can sort a table. How many rows are we talking?',
    },
    {
      character: 'stacy-queue',
      mood: 'idle',
      dialogue: 'Right now? Fifty. By Q3? Half a million. Should be fine though.',
    },
  ],
  challengeIds: ['bubble-sort', 'selection-sort', 'insertion-sort'],
}
